export default ({}) => {
    return {
        chart: {
            margin: [0, 0, 0, 0],
        },
    };
};
